
<template>
  <!-- <div> -->
    <div ref="mars3dContainer" :id="`mars3d-container-${mapKey}`" class="mars3d-container"></div>
    <!-- <div>
      <slot name='toolBar'></slot>
    </div> -->
  <!-- </div> -->
</template>

<script>
// require("../public/mars3d/mars3d.js");
import dy3dMap from "../js/dy3dMap.js";
import configJson from "../json/config.json";
const DYMAP = new dy3dMap()

export default {
  name: 'map-3d-viewer',
  props: {
    /**
     * 地图唯一性标识（必填）
     */
    mapKey: {
      type: String,
      default: '',
      required: true
    },
    /**
     * 视角中心
     */
    center: {
      type:Object,
      default: ()=>({}),
    },
    /**
     * 控制控件是否可显（键值对）
     */
    control: {
      type: Object,
      default: ()=>({}),
    },
    /**
     * 地形
     */
    terrain: {
      type: Object,
      default: ()=>({}),
    },
    /**
     * 底图
     */
    basemaps: {
      type: Array,
      default: () => [],
    },
    /**
     * 天空盒子
     */
     skyBox: {
      type: String,
      default: '',
    }
  },
  mounted() {
    this.getInfoAndInit()
  },
  beforeDestroy() {
    DYMAP.destroyed()
  },
  methods: {
    /**
     * 获取配置信息并进行地球初始化
     */
    getInfoAndInit(){
      let config = configJson.map3d
      this.validateParams(config)
      const map = DYMAP.init3DMap(`mars3d-container-${this.mapKey}`,config)
      console.log('>>>>>>>>地图加载完成>>>>>>>>',map);
      // 抛出事件
      this.$emit('loadedMap',map)
    },
    /**
     * 参数校验
     * @params {object} config 地图配置（见props）
     */
    validateParams(config){
      let center = Object.keys(this.center)
      if(center.length !== 0){
        config.scene.center = this.center
      }

      let control = Object.keys(this.control)
      if(control.length !== 0){
        control.forEach(key=>{
          config.control[key] = this.control[key]
        })
      }

      let terrain = Object.keys(this.terrain)
      if(terrain.length !== 0){
        config.terrain = this.terrain
      }

      if(this.basemaps.length !== 0){
        config.basemaps = this.basemaps
      }

      if(this.skyBox){
        config.scene.showSkyAtmosphere = false // 需要关闭
        let ground
        if(this.skyBox == 'sunny'){
          ground = {
            type: "ground",
            sources: {
              positiveX: "/img/skybox_near/qingtian/rightav9.jpg",
              negativeX: "/img/skybox_near/qingtian/leftav9.jpg",
              positiveY: "/img/skybox_near/qingtian/frontav9.jpg",
              negativeY: "/img/skybox_near/qingtian/backav9.jpg",
              positiveZ: "/img/skybox_near/qingtian/topav9.jpg",
              negativeZ: "/img/skybox_near/qingtian/bottomav9.jpg"
            }
          }
        }else if(this.skyBox == 'sunsetGlow'){
          ground = {
            type: "ground",
            sources: {
              positiveX: "/img/skybox_near/wanxia/SunSetRight.png",
              negativeX: "/img/skybox_near/wanxia/SunSetLeft.png",
              positiveY: "/img/skybox_near/wanxia/SunSetFront.png",
              negativeY: "/img/skybox_near/wanxia/SunSetBack.png",
              positiveZ: "/img/skybox_near/wanxia/SunSetUp.png",
              negativeZ: "/img/skybox_near/wanxia/SunSetDown.png"
            }
          }
        }else if(this.skyBox == 'blueSky'){
          ground = {
            type: "ground",
            sources: {
              positiveX: "/img/skybox_near/lantian/Right.jpg",
              negativeX: "/img/skybox_near/lantian/Left.jpg",
              positiveY: "/img/skybox_near/lantian/Front.jpg",
              negativeY: "/img/skybox_near/lantian/Back.jpg",
              positiveZ: "/img/skybox_near/lantian/Up.jpg",
              negativeZ: "/img/skybox_near/lantian/Down.jpg"
            }
          }
        }else if(this.skyBox == 'empty'){
          config.scene.showSkyAtmosphere = true // 需要关闭
        }
        config.scene.skyBox = ground
      }
    }
  },
}
</script>

<style>
.mars3d-container {
  height: 100%;
  overflow: hidden;
}
.mars3d-compass {
  bottom: 320px !important;
  right: 5px !important;
  left: auto !important;
}
.cesium-viewer-toolbar {
  right: 11px;
  bottom: 35px;
  top: auto;
}
.cesium-viewer-toolbar > .cesium-toolbar-button,
.cesium-navigationHelpButton-wrapper,
.cesium-viewer-geocoderContainer {
  margin-bottom: 5px;
  float: right;
  clear: both;
  text-align: center;
}
.cesium-button {
  background-color: #3f4854;
  color: #e6e6e6;
  fill: #e6e6e6;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  line-height: 32px;
}

/**cesium 底图切换面板*/
.cesium-baseLayerPicker-dropDown {
  bottom: 0;
  /* left: 40px; */
  right: 56px;
  max-height: 700px;
  margin-bottom: 5px;
}

/**cesium 帮助面板*/
.cesium-navigation-help {
  top: auto;
  bottom: 0;
  left: 40px;
  transform-origin: left bottom;
}

/**cesium 二维三维切换*/
.cesium-sceneModePicker-wrapper {
  width: auto;
}
.cesium-sceneModePicker-wrapper .cesium-sceneModePicker-dropDown-icon {
  float: left;
  margin: 0 3px;
}

/**cesium POI查询输入框*/
.cesium-viewer-geocoderContainer .search-results {
  left: 0;
  right: 40px;
  width: auto;
  z-index: 9999;
}
.cesium-geocoder-searchButton {
  background-color: #3f4854;
}
.cesium-viewer-geocoderContainer .cesium-geocoder-input {
  background-color: rgba(63, 72, 84, 0.7);
}
.cesium-viewer-geocoderContainer .cesium-geocoder-input:focus {
  background-color: rgba(63, 72, 84, 0.9);
}
.cesium-viewer-geocoderContainer .search-results {
  background-color: #3f4854;
}

/**cesium info信息框*/
.cesium-infoBox {
  top: 50px;
  background: rgba(63, 72, 84, 0.9);
}
.cesium-infoBox-title {
  background-color: #3f4854;
}

/**cesium 任务栏的FPS信息*/
.cesium-performanceDisplay-defaultContainer {
  top: auto;
  bottom: 35px;
  right: 50px;
}
.cesium-performanceDisplay-ms,
.cesium-performanceDisplay-fps {
  color: #fff;
}

/**cesium tileset调试信息面板*/
.cesium-viewer-cesiumInspectorContainer {
  top: 10px;
  left: 10px;
  right: auto;
  background-color: #3f4854;
}
</style>
